export const stylesFormalitiesModal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 650,
  p: 4,
  maxHeight: '90vh',
  display: 'flex',
  flexDirection: 'column',
};

export const stylesFormalitiesModalHeader = {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  mb: 3,
};

export const stylesFormalitiesModalTitle = {
  flex: '1',
};

export const stylesFormalitiesModalClose = {
  minWidth: 0,
  '& .MuiSvgIcon-root': {
    fontSize: 'h2.fontSize',
  },
};

export const stylesFormalitiesModalFooter = {
  display: 'flex',
  justifyContent: 'flex-end',
  pt: 3,
  gap: 2,
};
